<ng-container *ngIf="authService.checkSalespointProperty('fiscal_procedures_by')">
  <div class="menu-action-button" *ngIf="fiscalService.isOperationPending">
    <button mat-stroked-button color="primary" class="fiscal pull-left right-spacer" (click)="fiscalService.cancelOperation()">
      {{ 'general.api_fiscal_cancel' | translate }}
    </button>
  </div>
  <div class="menu-action-button">
    <button mat-flat-button color="primary" class="fiscal pull-left right-spacer" *ngIf="!fiscalService.isReady"
            (click)="fiscalService.startDay()" [disabled]="fiscalService.isOperationPending">
      <ng-container *ngIf="!fiscalService.isOperationPending">{{ 'general.api_fiscal_start_day' | translate }}</ng-container>
      <mat-spinner [diameter]="16" color="accent" *ngIf="fiscalService.isOperationPending"></mat-spinner>
    </button>
    <button mat-flat-button color="primary" class="fiscal pull-left right-spacer" #fiscalMenuBtn *ngIf="fiscalService.isReady"
            [matMenuTriggerFor]="fiscalMenu" (click)="fiscalService.getShiftStatus()" [disabled]="fiscalService.isOperationPending">
      <ng-container *ngIf="!fiscalService.isOperationPending">
        {{ 'general.api_fiscal_started' | translate }}
        <mat-icon class="svg-icon left-spacer" [svgIcon]="'arrow_down'"></mat-icon>
      </ng-container>
      <mat-spinner [diameter]="16" *ngIf="fiscalService.isOperationPending"></mat-spinner>
    </button>
  </div>
  <div class="menu-action-button" *ngIf="!routeService.isWindow">
    <button mat-flat-button color="primary" class="fiscal pull-left right-spacer" #cashMenuBtn
            [matMenuTriggerFor]="cashMenu" (click)="cashService.updateBalance()">
      {{ 'general.api_cash_menu' | translate }}
      <mat-icon class="svg-icon left-spacer" [svgIcon]="'arrow_down'"></mat-icon>
    </button>
  </div>
</ng-container>
<mat-menu class="mat-menu fiscal-menu" #fiscalMenu="matMenu" yPosition="below" xPosition="before">
  <div (click)="$event.stopPropagation()" *ngIf="fiscalService.isReady">
    <div class="heading-5 flex flex-grow">
      <span>{{ 'general.api_fiscal_balance' | translate }}:</span>
      <span class="align-right text-base bold">{{ fiscalService.shift.balance | price }}</span>
    </div>
    <div class="flex flex-grow">
      <div class="flex flex-column flex-flat">
        <app-numeric-input [type]="NumericInputType.Price" [label]="'general.api_fiscal_cash_in'"
                           [(value)]="cashInFiscal" (inputKeyup)="runCashIn($event)" [withSuffix]="true">
          <button mat-button class="input-button icon-button suffix-button" (click)="runCashIn()" [disabled]="!cashInFiscal">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
          </button>
        </app-numeric-input>
        <div>
          <div class="heading-5">{{'general.api_fiscal_start_time' | translate}}</div>
          {{moment.utc(fiscalService.shift.start).format(viewService.conf.dateTimeFormatWithSeconds)}}
        </div>
      </div>
      <div class="flex flex-column flex-flat">
        <app-numeric-input [type]="NumericInputType.Price" [label]="'general.api_fiscal_cash_out'"
                           [(value)]="cashOutFiscal" (inputKeyup)="runCashOut($event)" [withSuffix]="true">
          <button mat-button class="input-button icon-button suffix-button" (click)="runCashOut()" [disabled]="!cashOutFiscal">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
          </button>
        </app-numeric-input>
        <div>
          <div class="heading-5">{{'general.api_fiscal_start_by' | translate}}</div>
          {{ fiscalService.shift.firstName }} {{ fiscalService.shift.lastName }}
        </div>
      </div>
    </div>
    <br>
    <div class="flex flex-grow">
      <button mat-flat-button color="primary" (click)="fiscalService.xReport(); fiscalMenuTrigger.closeMenu();">
        {{ 'general.api_fiscal_print_x_report' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="fiscalService.feed(); fiscalMenuTrigger.closeMenu();">
        {{ 'general.api_fiscal_operation_feed' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="fiscalService.cut(); fiscalMenuTrigger.closeMenu();">
        {{ 'general.api_fiscal_operation_cut' | translate }}
      </button>
    </div>
    <button mat-stroked-button color="primary" class="max-width top-spacer" (click)="fiscalService.endDay(); fiscalMenuTrigger.closeMenu();">
      {{ 'general.api_fiscal_end_day' | translate }}
    </button>
  </div>
</mat-menu>
<mat-menu class="mat-menu fiscal-menu" #cashMenu="matMenu" yPosition="below" xPosition="before">
  <div (click)="$event.stopPropagation()" *ngIf="cashService.balance && !routeService.isWindow">
    <div class="heading-5 flex flex-grow">
      <span>{{ 'general.api_fiscal_balance' | translate }}:</span>
      <span class="align-right text-base bold">{{ cashService.balance.balance | price }}</span>
    </div>
    <div class="flex flex-grow">
      <div class="flex flex-column flex-flat">
        <app-numeric-input [type]="NumericInputType.Price" [label]="'general.api_fiscal_cash_in'"
                           [(value)]="cashInFiscal" (inputKeyup)="runCashIn($event)" [withSuffix]="true">
          <button mat-button class="input-button icon-button suffix-button" (click)="runCashIn()" [disabled]="!cashInFiscal">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
          </button>
        </app-numeric-input>
      </div>
      <div class="flex flex-column flex-flat">
        <app-numeric-input [type]="NumericInputType.Price" [label]="'general.api_fiscal_cash_out'"
                           [(value)]="cashOutFiscal" (inputKeyup)="runCashOut($event)" [withSuffix]="true">
          <button mat-button class="input-button icon-button suffix-button" (click)="runCashOut()" [disabled]="!cashOutFiscal">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
          </button>
        </app-numeric-input>
      </div>
    </div>
  </div>
</mat-menu>
